var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { CommonRequestService } from './common-request.service';
import { UserService } from './user.service';
import { AppSettings } from 'app/app.settings';
var IntegratorService = /** @class */ (function () {
    function IntegratorService(requestService, userService) {
        this.requestService = requestService;
        this.userService = userService;
    }
    IntegratorService.prototype.getIntegratorClients = function (customerId) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = AppSettings.serviceRootUrl + 'azgiv/integratorClient';
            customerId = customerId || _this.userService.getUserInfo().customerId;
            var params = {
                customerIdIntegrator: customerId.toString()
            };
            _this.requestService.requestGet(url, {
                params: params
            }, function (rsp) {
                var clients = [];
                var promises = [];
                if (rsp.data) {
                    rsp.data.forEach(function (d) {
                        var cusInfoPromise = new Promise(function (resolveCus, rejectCus) { return __awaiter(_this, void 0, void 0, function () {
                            var cusInfo, err_1;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        _a.trys.push([0, 2, , 3]);
                                        return [4 /*yield*/, this.userService.getCustomerInfo(d.gia_cus_id_client, false, true)];
                                    case 1:
                                        cusInfo = _a.sent();
                                        clients.push({
                                            cusId: d.gia_cus_id_client,
                                            cusNameShort: d.cus_name_short_client,
                                            parentId: cusInfo.parentId,
                                            integratorCusId: d.gia_cus_id_integrator,
                                            integratorCusNameShort: d.cus_name_short_integrator,
                                            givState: cusInfo.givState,
                                            adminEmails: cusInfo.adminEmails
                                        });
                                        resolveCus(cusInfo);
                                        return [3 /*break*/, 3];
                                    case 2:
                                        err_1 = _a.sent();
                                        console.log(err_1);
                                        rejectCus(err_1);
                                        return [3 /*break*/, 3];
                                    case 3: return [2 /*return*/];
                                }
                            });
                        }); });
                        promises.push(cusInfoPromise);
                    });
                }
                Promise.all(promises)
                    .catch(function (err) { return reject(err); })
                    .then(function (rsp) {
                    clients.sort(function (a, b) {
                        if (a.cusNameShort < b.cusNameShort) {
                            return -1;
                        }
                        else if (a.cusNameShort > b.cusNameShort) {
                            return 1;
                        }
                        else {
                            return 0;
                        }
                    });
                    _this.userService.clients = clients;
                    resolve(clients);
                });
            }, function (err) { return reject(err); });
        });
    };
    IntegratorService.prototype.addIntegratorClient = function (integratorCusId, clientCusId, adminUserId) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = AppSettings.serviceRootUrl + 'azgiv/integratorClient';
            var body = {
                customerIdIntegrator: integratorCusId,
                customerIdClient: clientCusId,
                sessionOwnerId: adminUserId
            };
            _this.requestService.requestPost(url, body, function (rsp) {
                resolve(rsp);
            }, function (err) { return reject(err); });
        });
    };
    IntegratorService.prototype.deleteIntegratorClient = function (giaId) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = AppSettings.serviceRootUrl + 'azgiv/integratorClient';
            _this.requestService.requestDelete(url, {
                body: {
                    giaId: giaId,
                    sessionOwnerId: _this.userService.getUserInfo().userId
                }
            }, function (rsp) { return resolve(rsp); }, function (err) { return reject(err); });
        });
    };
    IntegratorService.prototype.getIntegrators = function (clientCustomerId, updateList) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = AppSettings.serviceRootUrl + 'azgiv/integrators';
            var params = {};
            if (clientCustomerId) {
                params.customerIdClient = clientCustomerId.toString();
            }
            _this.requestService.requestGet(url, {
                params: params
            }, function (rsp) {
                var integrators = [];
                if (rsp.data) {
                    rsp.data.forEach(function (d) {
                        var integrator = {
                            cusId: d.cus_id,
                            nameShort: d.cus_name_short,
                            nameLong: d.cus_name_long,
                            adminUsers: d.admin_users
                        };
                        if (clientCustomerId) {
                            integrator.giaId = d.gia_id;
                        }
                        integrators.push(integrator);
                    });
                }
                if (updateList) {
                    _this.integrators = integrators;
                }
                resolve(integrators);
            }, function (err) { return reject(err); });
        });
    };
    return IntegratorService;
}());
export { IntegratorService };
